import { loadUsers, loadSelectData } from './user.store';
import { checkStoreStatus } from '@/util/util';
import store from '@/store/store';

export function getUserWrapper(id) {
  checkStoreStatus('users', 'users', loadUsers);
  return store.getState().getIn(['data', 'users'])
    .filter(user => user.get('id') == id)
    .first();
}

export function getUsersListWrapper() {
  if (!checkStoreStatus('users', 'users', loadUsers)) {
    return undefined;
  }
  return store.getState().getIn(['data', 'users']);
}

export function getUsersSelectWrapper() {
  if (!checkStoreStatus('users_select', 'users_select', loadSelectData)) {
    return undefined;
  } return true;
}
